import { Component } from '@angular/core'
import { TranslateService } from '@ngx-translate/core'

@Component({
  selector: 'flowaccount-receipt-mobile-app',
  templateUrl: './receipt-mobile-app.component.html',
  styleUrls: ['./receipt-mobile-app.component.scss'],
})
export class ReceiptMobileAppComponent {
  public getImageLang =
    this.translate.currentLang === 'th'
      ? 'https://flowaccountcdn.com/new_landing/image/functions/receipt/receipt-section4-th-v2.webp'
      : 'https://flowaccountcdn.com/new_landing/image/functions/receipt/receipt-section4-eng-v2.webp'
  public getImageLangMobile =
    this.translate.currentLang === 'th'
      ? 'https://flowaccountcdn.com/new_landing/image/functions/receipt/receipt-section4-th-v2-mobile.webp'
      : 'https://flowaccountcdn.com/new_landing/image/functions/receipt/receipt-section4-eng-v2-mobile.webp'
  public getImage =
    this.translate.currentLang === 'th'
      ? 'https://flowaccountcdn.com/new_landing/image/functions/receipt/receipt-section4-th-v2.png'
      : 'https://flowaccountcdn.com/new_landing/image/functions/receipt/receipt-section4-eng-v2.png'
  public getAltText = this.translate.currentLang === 'th' ? 'แอพทำสลิปขายของ' : 'Sales Receipt App'
  constructor(public translate: TranslateService) {}
}
